module.exports = __webpack_public_path__ + "img/img-7e5565.png";